import React from "react";
import Image from "next/image";
import "@/common/Common.css";

function BildTextInfo({
  image,
  title,
  text,
  revert,
  isBig,
  alt,
  addPTag,
  h2,
  fontSize = "38px",
}) {
  return (
    <div className={`${isBig ? "Banner-item-big" : "Banner-item"} `}>
      {revert ? (
        <div className="Banner-img-text-wrapper">
          <div
            className={`${
              revert ? "Banner-text-wrapper order-2" : "Banner-text-wrapper"
            }`}
          >
            {h2 ? (
              <h2
                style={{
                  fontSize: fontSize,
                }}
              >
                {title}
              </h2>
            ) : (
              <h3
                style={{
                  fontSize: fontSize,
                }}
              >
                {title}
              </h3>
            )}

            {addPTag ? <p>{text}</p> : <>{text}</>}
          </div>
          {image && (
            <div
              className={`${
                isBig ? "Banner-image-wrapper-big" : "Banner-image-wrapper"
              } ${revert ? "order-1" : ""}`}
            >
              <Image
                src={image}
                alt={alt}
                fill
                className="Banner-image"
                // On mobile, the banner section has 24px side padding; reflect that so Next/Image picks a smaller src.
                sizes="(max-width: 1040px) calc(100vw - 48px), 440px"
              />
            </div>
          )}
        </div>
      ) : (
        <div className="Banner-img-text-wrapper">
          {image && (
            <div
              className={`${
                isBig ? "Banner-image-wrapper-big" : "Banner-image-wrapper"
              }`}
            >
              <Image
                src={image}
                alt={alt}
                fill
                className="Banner-image"
                // On mobile, the banner section has 24px side padding; reflect that so Next/Image picks a smaller src.
                sizes="(max-width: 1040px) calc(100vw - 48px), 440px"
              />
            </div>
          )}

          <div className="Banner-text-wrapper">
            {h2 ? (
              <h2
                style={{
                  fontSize: fontSize,
                }}
              >
                {title}
              </h2>
            ) : (
              <h3
                style={{
                  fontSize: fontSize,
                }}
              >
                {title}
              </h3>
            )}
            {addPTag ? <p>{text}</p> : <>{text}</>}
          </div>
        </div>
      )}
    </div>
  );
}

export default BildTextInfo;
